// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import debug from "../helpers/debug";

const createPaymentMethod = (
  tokenId: string,
  cardholderName: string,
  country: string,
  postcode: string
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  debug("createPaymentMethod", tokenId, cardholderName, country, postcode);

  return apiInstance.post(`/v5/users/payment-sources`, {
    token_id: tokenId,
    cardholder_name: cardholderName,
    country,
    postcode
  });
};

export default createPaymentMethod;
